<template>
  <div>
    <b-tabs>
      <b-tab title="Gifts">
        <h1>Gifts</h1>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
export default {
  name: "WorkFlowsIt",
};
</script>